<template>
  <div>
    <!-- MODAL NAVIGATION USER-->
    <b-button
      v-ripple.400="'rgba(113, 102, 240, 0.15)'"
      v-b-modal.modal-navigation-user
      class="waves-effect"
      variant="outline-warning">
        {{$t('user_access_data')}}
    </b-button>
    <b-modal
      id="modal-navigation-user"
      cancel-variant="outline-secondary"
      hide-footer="true"
      scrollable
      size="xl"
      :title="$t('user_access_data')">
      <b-table
              hover
              caption-top
              responsive="sm"
              table-variant="warning"
              :items="listItensUserAccess"
              :fields="fieldsTableUserAccessModal">
      </b-table>
    </b-modal>
  </div>
</template>

<script>

import {
  BContainer,
  BRow,
  BCol,
  BCard,
  BTable,
  BCardText,
  BCardTitle,
  BCardFooter,
  BImg,
  BForm,
  BButton,
  VBTooltip
} from 'bootstrap-vue'

export default {
  directives: {
    'b-tooltip': VBTooltip,
  },
  components: {
    BContainer,
    BCard,
    BCardText,
    BCardTitle,
    BCardFooter,
    BImg,
    BRow,
    BCol,
    BForm,
    BButton,
    BTable
  },
  props: {
    navigationField: {
      type: Object,
      default: null
    }
  },
  data: () => ({
    showModal: false,
    fieldsTableUserAccessModal:[
      { key: 'ip', label: 'IP' },
      { key: 'port', label: 'Porta' },
      { key: 'osName', label: 'OS Name' },
      { key: 'osVersion', label: 'OS Version' },
      { key: 'browserName', label: 'Browser Name' },
      { key: 'browserVersion', label: 'Browser Version' },
    ],
  }),
  computed: {
    listItensUserAccess () {
      let itens = []
      if(this.navigationField){
        itens.push(this.navigationField);
      }
      return itens;
    }
  },
  methods: {

  },

  beforeMount() {

  }
}
</script>
<style scoped>

</style>
